export const serverTime = {
  offsetMs: 0,
  _syncPromise: null,

  nowMs() {
    return Date.now() + this.offsetMs;
  },

  sync() {
    if (!this._syncPromise) {
      this._syncPromise = fetch('/server-time.php', { cache: 'no-store' })
        .then(res => res.ok ? res.json() : null)
        .then(data => {
          if (data) {
            this.offsetMs = (data.now * 1000) - Date.now();
          }
        })
        .catch(e => {
          console.warn('Failed to sync server time, using client clock only', e);
        });
    }
    return this._syncPromise;
  },
};
